import { render } from "./SingleValue.vue?vue&type=template&id=23dcb175&scoped=true&ts=true"
import script from "./SingleValue.vue?vue&type=script&lang=ts"
export * from "./SingleValue.vue?vue&type=script&lang=ts"

import "./SingleValue.vue?vue&type=style&index=0&id=23dcb175&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23dcb175"]])

export default __exports__